import API_BASE_URL from "../config";

const authHeaders = () => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

const handle = async (res) => {
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(text || `Request failed with status ${res.status}`);
  }
  const text = await res.text();
  return text ? JSON.parse(text) : null;
};

export const submitRequest = (employeeId, payload) =>
  fetch(`${API_BASE_URL}/api/it-requests/${employeeId}`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify(payload),
  }).then(handle);

export const listByEmployee = (employeeId) =>
  fetch(`${API_BASE_URL}/api/it-requests/employee/${employeeId}`, {
    headers: authHeaders(),
  }).then(handle);

export const listAll = (page = 0, size = 50) =>
  fetch(`${API_BASE_URL}/api/it-requests?page=${page}&size=${size}`, {
    headers: authHeaders(),
  }).then(handle);

export const updateStatus = (id, payload) =>
  fetch(`${API_BASE_URL}/api/it-requests/${id}`, {
    method: "PUT",
    headers: authHeaders(),
    body: JSON.stringify(payload),
  }).then(handle);

export const exportExcel = async (search, status, dateFrom, dateTo) => {
  const params = new URLSearchParams();
  if (search) params.set("search", search);
  if (status && status !== "ALL") params.set("status", status);
  if (dateFrom) params.set("from", dateFrom);
  if (dateTo) params.set("to", dateTo);

  const res = await fetch(`${API_BASE_URL}/api/it-requests/report?${params}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
  if (!res.ok) throw new Error("Failed to download report");

  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  const date = new Date().toISOString().slice(0, 10);
  const hasFilters = Boolean(search) || (status && status !== "ALL") || dateFrom || dateTo;
  a.href = url;
  a.download = hasFilters ? `IT_Support_Requests_Filtered_${date}.xlsx` : `IT_Support_Requests_${date}.xlsx`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};
